import { useState } from 'react';

export default function SupportHeader() {
  const [open, setOpen] = useState(false);
  const [openItem, setOpenItem] = useState<'motiva' | 'eco' | null>(null);

  return (
    <div className="w-full bg-[#111] border-t border-[#393939]">
      <button
        className="w-full flex items-center justify-between px-4 py-4  focus:outline-none select-none md:max-w-7xl md:mx-auto p-3"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <h2 className="text-white text-xl font-bold text-left">Central de atendimento</h2>
        <svg
          width="32" height="32" viewBox="0 0 48 48" fill="none"
          className={`transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
        >
          <path d="M12 18L24 30L36 18" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      <div
        className={`overflow-hidden w-full transition-all duration-500 bg-[#e5e7eb] ${open ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
        style={{ transitionProperty: 'max-height, opacity' }}
      >
        <div className="md:max-w-7xl md:mx-auto">
          <div className="px-4 py-4 border-b border-[#E0E0E0]">
            <button
              className="w-full flex items-center justify-between focus:outline-none select-none"
              onClick={() => setOpenItem(openItem === 'motiva' ? null : 'motiva')}
              aria-expanded={openItem === 'motiva'}
            >
              <span className="text-black text-lg font-bold">Motiva</span>
              <svg
                width="28" height="28" viewBox="0 0 40 40" fill="none"
                className={`transition-transform duration-300 ${openItem === 'motiva' ? 'rotate-180' : ''}`}
              >
                <path d="M12 16L20 24L28 16" stroke="#181818" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div
              className={`overflow-hidden transition-all duration-500 ${openItem === 'motiva' ? 'max-h-20 opacity-100' : 'max-h-0 opacity-0'}`}
              style={{ transitionProperty: 'max-height, opacity' }}
            >
              <a
                href="https://www.motiva.com.br/contatos"
                target="_blank"
                rel="noopener noreferrer"
                className="block mt-2 text-base font-bold text-[#888]"
              >
                www.motiva.com.br/contatos
              </a>
            </div>
          </div>
          <div className="px-4 py-4 border-b border-[#E0E0E0]">
            <button
              className="w-full flex items-center justify-between focus:outline-none select-none"
              onClick={() => setOpenItem(openItem === 'eco' ? null : 'eco')}
              aria-expanded={openItem === 'eco'}
            >
              <span className="text-black text-lg font-bold">Eco Rodovias</span>
              <svg
                width="28" height="28" viewBox="0 0 40 40" fill="none"
                className={`transition-transform duration-300 ${openItem === 'eco' ? 'rotate-180' : ''}`}
              >
                <path d="M12 16L20 24L28 16" stroke="#181818" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div
              className={`overflow-hidden transition-all duration-500 ${openItem === 'eco' ? 'max-h-20 opacity-100' : 'max-h-0 opacity-0'}`}
              style={{ transitionProperty: 'max-height, opacity' }}
            >
              <a
                href="https://freeflow.econoroeste.com.br/fale-conosco"
                target="_blank"
                rel="noopener noreferrer"
                className="block mt-2 text-base font-bold text-[#888]"
              >
                freeflow.econoroeste.com.br/fale-conosco
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 